import { ReactElement } from 'react';
import { Stack, StackProps } from '@mui/material';

export const CheckSuccess = (props: StackProps): ReactElement => (
    <Stack
        typography="body1"
        justifyContent="flex-start"
        textAlign="center"
        alignSelf="flex-start"
        gap={2}
        // sx={{ w: 7.5 }} // TODO: check, this is not recognized by the browser
        {...props}
    >
        <img src="assets/images/check-pool-blau.webp" alt="success" />
    </Stack>
);
